<template>
  <div class="page">
    <div class="page__bd">
      <div class="form-preview weui-form-preview">
        <div class="weui-form-preview__hd">
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">单据编号</label>
            <em class="weui-form-preview__value">{{form.main.bpc_code}}</em>
          </div>
        </div>
        <custom-layout class="weui-form-preview__bd" :view-config="customViewConfig">
          <div class="weui-form-preview__item" slot="bpc_date">
            <label class="weui-form-preview__label">{{customLabel.bpc_date || "异动日期"}}</label>
            <span class="weui-form-preview__value" v-format="'yyyy-MM-dd'">{{form.main.bpc_date}}</span>
          </div>
          <div class="weui-form-preview__item" slot="bpc_kind">
            <label class="weui-form-preview__label">{{customLabel.bpc_kind || "异动类型"}}</label>
            <span class="weui-form-preview__value">{{form.main.bpc_kind}}</span>
          </div>
          <div class="weui-form-preview__item" slot="bpc_vendname">
            <label class="weui-form-preview__label">{{customLabel.bpc_vendname || "供应商名称"}}</label>
            <span class="weui-form-preview__value">{{form.main.bpc_vendname}}</span>
          </div>
          <div class="weui-form-preview__item" slot="bpc_currency">
            <label class="weui-form-preview__label">{{customLabel.bpc_currency || "币别"}}</label>
            <span class="weui-form-preview__value">{{form.main.bpc_currency}}</span>
          </div>
         
          <div class="weui-form-preview__item" slot="bpc_bapcode"> 
            <label class="weui-form-preview__label">{{customLabel.bpc_bapcode || "来源应付票据"}}</label>
            <span class="weui-form-preview__value">{{form.main.bpc_bapcode}}</span>
          </div>
        </custom-layout>
      </div>
      <div class="form-preview weui-form-preview">
        <div class="weui-form-preview__bd">
          <div class="weui-form-preview__item" v-if="form.main.bpc_remark">
            <label class="weui-form-preview__label">备注</label>
            <span class="weui-form-preview__value">{{form.main.bpc_remark}}</span>
          </div>
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">录入人</label>
            <span class="weui-form-preview__value">{{form.main.creatorName}}</span>
          </div>
          <div class="weui-form-preview__item" v-if="form.main.bpc_auditman">
            <label class="weui-form-preview__label">审核人</label>
            <span class="weui-form-preview__value">{{form.main.bpc_auditman}}</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import CustomLayout from "@/components/layout/CustomLayout.vue";
import process from "@/mixins/process.js";

export default {
  mixins: [process],
  components: {
    CustomLayout,
    
  },
  data() {
    return {
      baseUrl: "/api/money/billapchange",
      caller: "BillAPChange",
      xtype: "money-billapchange-formpanel",
    };
  }
}
</script>
